import { render, staticRenderFns } from "./CzNotice.vue?vue&type=template&id=822ab598&scoped=true&"
import script from "./CzNotice.vue?vue&type=script&lang=ts&"
export * from "./CzNotice.vue?vue&type=script&lang=ts&"
import style0 from "./CzNotice.vue?vue&type=style&index=0&id=822ab598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822ab598",
  null
  
)

export default component.exports